import React, {useEffect, useState} from 'react';
import { useNavigate ,useLocation} from 'react-router-dom';
import login from "../assets/login.gif"; 
import payment from "../assets/payment.gif"; 


import { useLoading } from '../components/LoadingProvider';

import { getPublicPlanDetail , gotoZarinpalGateway } from '../services/plans/publicPlansService';
import { validateDiscountCode } from '../services/discounts/publicDiscountsService';


const InvoicePage = () => {
  const navigate = useNavigate();
  const [showCoupon, setShowCoupon] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [couponApplied, setCouponApplied] = useState(null);
  const [discount, setDiscount] = useState(0);

  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);

  // const itemId = queryParams.get('item');
  const { showLoading, hideLoading, toast } = useLoading()

  const BASE_URL = process.env.REACT_APP_BASE_URL;


  const [invoice, setInvoice] = useState({
      id: '',
      planId : '',
      amount: 0,
      currency: '',
      package:'',
      user:null,
      date: new Date().toLocaleDateString('fa-IR'),
  });

  const [itemId, setItemId] = useState(queryParams.get('item'));

    useEffect(()=>{

        showLoading();

          getPublicPlanDetail(itemId)
          .then(d=>{
              console.log('getPublicPlanDetail :::: ',d)

            setInvoice({
                id: 'INV-20250519-001',
                planId : d.data._id,
                amount: d.data.finalPrice,
                currency: d.data.priceUnitLabel,
                package: ` ${d.data.durationDays} روزه`,
                user: d.data.currentUserPhone ?? null,
                vat: d.data.VAT,
                date: new Date().toLocaleDateString('fa-IR'),
            })

          })
          .catch(err=>{
              console.error(err)
              toast.error("سفارش نامعتبر است")

              setTimeout(() => {
                
                    navigate('/plans?error=invalid_order'); // یا navigate('/payment/fail') بر اساس سناریو


              }, 1000);

          })
          .finally(()=>{
            hideLoading();
          })

    },[itemId]);




  const checkCoupon = ()=>{
        showLoading();

      validateDiscountCode(coupon)
      .then(d=>{
          // console.log('COUPON ::: ',d)

        if(d.code)
        {
           setDiscount(d.percent/100);
           setCouponApplied(d);
        }
        else{
          toast.error("کد تخفیف نامعتبر است")
        }

      })
      .catch(err=>{
          console.error('COUPON ::: ',err)
          toast.error("کد تخفیف نامعتبر است")

      })
      .finally(()=>{
            hideLoading();

      });

  }


  // const invoice = {
  //   id: 'INV-20250519-001',
  //   planId : itemId,
  //   amount: '49,000',
  //   currency: 'تومان',
  //   package: 'پلن حرفه‌ای',
  //   user: 'کاربر عزیز',
  //   date: new Date().toLocaleDateString('fa-IR'),
  // };

  const handleProceedToBank = () => {
    // شبیه‌سازی انتقال به درگاه بانکی

   // backend api call

   // redirect to payment gateway
        showLoading();

    const sendToBank = {
      amount : invoice.amount, 
      planId : invoice.planId, 
      couponId : couponApplied?.id,
      couponCode : couponApplied?.code,
      gateway: 'zarinpal'
    };


    gotoZarinpalGateway(sendToBank)
    .then(data=>{
      console.log(data)
      toast.success("مثلا هدایت به زرین پال")
      
    })
    .catch(err=>{
      console.error(err)
    })
    .finally(()=>{

      setTimeout(() => {
            hideLoading();
      }, 2000);

    });

    console.log(sendToBank);

    navigate('/payments/success/1000'); // یا navigate('/payment/fail') بر اساس سناریو
  };


  const handleLoginToContinue = () => {

    navigate(`/login?return=${window.location.pathname}`);  
  };

    const handleApplyCoupon = () => {


    checkCoupon();

    // // نمونه ساده: اگر کد برابر "OFF10" باشد 10% تخفیف بدهد
    // if (coupon.trim().toUpperCase() === 'OFF10') {
    //   setDiscount(0.1);
    //   setCouponApplied(true);
    // } else {
    //   setDiscount(0);
    //   setCouponApplied(false);
    //   alert('کد تخفیف معتبر نیست');
    // }
  };

    // محاسبه مبلغ نهایی با تخفیف
  // const amountNumber = Number(invoice.amount.replace(/,/g, ''));
  const amountNumber =  invoice.amount;
  const discountedAmount = discount ? amountNumber - amountNumber * discount : amountNumber;


  return (
    <div className="container mt-5">
      <div className='row'>
       
         <div className='col col-md-8'>
  <div className="card shadow-sm">
        <div className="card-body text-center">
          <h1 className="card-title mb-4">بررسی فاکتور</h1>
          <p className="text-muted mb-4">کاربر عزیز، لطفاً اطلاعات فاکتور خود را بررسی کنید:</p>
          <ul className="list-group list-group-flush text-end mb-4">
            <li className="list-group-item"><strong>کد فاکتور:</strong> {invoice.id}</li>
            <li className="list-group-item"><strong>پلن:</strong> {invoice.package}</li>
            { invoice.user ?  <li className="list-group-item"><strong>کاربر:</strong> {invoice.user}</li> : ''}

          
            {/* <li className="list-group-item"><strong>مبلغ:</strong> {invoice.amount} {invoice.currency}</li> */}
          
             <li className="list-group-item"><strong>مبلغ (با احتساب 
               {' '+invoice.vat} 
               درصد ارزش افزوده): </strong> 
              {discount ? (
                <>
                  <span style={{ textDecoration: 'line-through', color: '#888', marginLeft: 8 }}>{invoice.amount}</span>
                  <span style={{ color: 'green', fontWeight: 'bold' }}>
                    {discountedAmount.toLocaleString()} {invoice.currency}
                  </span>
                </>
              ) : (
                <>
                  {invoice.amount} {invoice.currency}
                </>
              )}
            </li>

            <li className="list-group-item"><strong>تاریخ:</strong> {invoice.date}</li>

            <li className="list-group-item"><strong>     هزینه سرویس خریداری شده به هیچ عنوان عودت نمی شود   </strong>  </li>

          </ul>


   {/* بخش کد تخفیف */}
         {invoice.user && <div className="mb-4 text-end">
            <button
              className="btn btn-link"
              type="button"
              onClick={() => setShowCoupon(!showCoupon)}
              style={{ textDecoration: 'none' }}
            >
              {showCoupon ? 'بستن کد تخفیف' : ' کد تخفیف دارید؟'}
            </button>
            {showCoupon && (
              <div className="mt-3">
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="کد تخفیف را وارد کنید"
                  value={coupon}
                  onChange={e => setCoupon(e.target.value)}
                  disabled={couponApplied}
                />
                <button
                  className="btn btn-outline-primary"
                  onClick={handleApplyCoupon}
                  disabled={couponApplied}
                >
                  {couponApplied ? 'اعمال شد' : 'اعمال کد'}
                </button>
                {couponApplied && (
                  <div className="text-success mt-2">کد تخفیف با موفقیت اعمال شد!</div>
                )}
              </div>
            )}
          </div> }

            {invoice.user ? 
             <button
            onClick={handleProceedToBank}
            className="btn btn-success btn-lg"
          >
            پرداخت و ورود به درگاه بانکی
          </button>
            :

             <button
            onClick={handleLoginToContinue}
            className="btn btn-danger btn-lg"
          >
           ورود و ادامه خرید
          </button>

            }
         
        </div>
      </div>
        </div>
         <div className='col col-md-4'>
                <div className='mb-5 text-center'>
                {
                  invoice.user  ? 
                  
                  <img src={payment} alt="payment" width={512} style={{'width':'100%;'}}/>
                  :
                  
                  <img src={login} alt="login" width={512} style={{'width':'100%;'}}/>
                }

                        
                </div>
             
        </div>
      </div>
    
    </div>
  );
};

export default InvoicePage;

